import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    if (!sid) { navigate("/compte"); return; }
    axios.post(`${API}/auth/google/session`, { session_id: sid })
      .then((r) => { setUser(r.data); })
      .catch(() => {})
      .finally(() => {
        window.history.replaceState({}, "", "/compte");
        navigate("/compte");
      });
  }, []); // eslint-disable-line

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 text-slate-500">
      <Loader2 className="h-10 w-10 animate-spin text-blue-600" />
      <p>Connexion en cours...</p>
    </div>
  );
}
